const styles = {
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(0, 0, 0, 0.8)",
    zIndex: 1000,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "20px",
  },
  header: {
    position: "absolute",
    top: "5px",
    right: "5px",
    zIndex: 1001,
    display: "flex",
    gap: "8px",
  },
  iconButton: {
    backgroundColor: "rgba(0, 0, 0, 0.3)",
    border: "none",
    borderRadius: "50%",
    color: "white",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "40px",
    height: "40px",
    transition: "background-color 0.2s ease-in-out",
    "&:hover": {
      backgroundColor: "rgba(0, 0, 0, 0.5)",
    },
  },
  closeButton: {
    backgroundColor: "rgba(220, 53, 69, 0.8)",
    "&:hover": {
      backgroundColor: "rgba(220, 53, 69, 1)",
    },
  },
  content: {
    width: "100%",
    height: "100%",
    maxWidth: "1200px",
    maxHeight: "90vh",
    overflow: "hidden",
    display: "flex",
    flexDirection: "column",
    backgroundColor: "#fff",
    borderRadius: "12px",
    boxShadow: "0 8px 30px rgba(0, 0, 0, 0.2)",
    position: "relative",
  },
  documentContainer: {
    flex: 1,
    width: "100%",
    overflow: "auto",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "20px",
  },
  document: {
    maxWidth: "100%",
    maxHeight: "100%",
    border: "none",
    transformOrigin: "center center",
    borderRadius: "8px",
  },
  errorContainer: {
    textAlign: "center",
    padding: "40px",
    color: "#721c24",
    backgroundColor: "#f8d7da",
    border: "1px solid #f5c6cb",
    borderRadius: "8px",
    maxWidth: "500px",
  },
  unsupportedContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "100%",
    height: "100%",
  },
  unsupportedMessage: {
    textAlign: "center",
    padding: "40px",
    backgroundColor: "#fff3cd",
    border: "1px solid #ffeaa7",
    borderRadius: "8px",
    color: "#856404",
    maxWidth: "500px",
  },
  downloadButton: {
    padding: "12px 24px",
    backgroundColor: "#007bff",
    color: "white",
    border: "none",
    borderRadius: "4px",
    cursor: "pointer",
    fontSize: "16px",
    marginTop: "20px",
    transition: "background-color 0.2s",
  },
};

export default styles;
